import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, createSlots as _createSlots } from "vue"

import { computed, onBeforeMount } from 'vue'

import DocLayout from '@/app/components/doc/Layout.vue'
import PrevNext from '@/app/components/doc/PrevNext.vue'
import Chapter from '@/app/components/doc/reading/Chapter.vue'
import Exercise from '@/app/components/doc/reading/Exercise.vue'
import EarlyAccessBannerBook from '@/app/components/doc/EarlyAccessBannerBook.vue'
import EarlyAccessBannerPodcast from '@/app/components/doc/EarlyAccessBannerPodcast.vue'

import AudioPlayer from '@/app/components/doc/player/Player.vue'
import AudioPlayerDisabled from '@/app/components/doc/player/PlayerDisabled.vue'

import { emitter } from '@/services/mitt'
import { DocView } from '@/models/doc'
import { AnnotationWithContent } from '@/models/interfaces'
import { backend } from '@/services/backend'
import {
  onBeforeRouteUpdate,
  RouteLocationNormalized,
  useRoute,
} from 'vue-router'
import { Sentry } from '@/services/sentry'
import { aiLabel13537ExperimentVariant } from '@/services/ab'
import { Mixpanel } from '@/analytics/mixpanel'


export default /*#__PURE__*/_defineComponent({
  __name: 'Content',
  props: {
    doc: null
  },
  setup(__props: any) {

const props = __props as {
  doc: DocView
};



const route = useRoute()

onBeforeMount(async () => {
  await handleHighlight(route)
  Mixpanel.setFirstDoc('Viewed', props.doc.title, props.doc.doc_type)
})

onBeforeRouteUpdate(async (to: RouteLocationNormalized) => {
  await handleHighlight(to)
})

function onDocContentClick(event: any): void {
  emitter.emit('docContentClicked', event)
}

/**
 * Fetch a highlight by ID if the `highlight` query param is present.
 */
async function _maybeFetchHighlight(
  route: RouteLocationNormalized,
): Promise<AnnotationWithContent | undefined> {
  const highlightId = route.query?.highlight as string | undefined
  if (!highlightId) {
    return undefined
  }
  try {
    return await backend.getHighlight(highlightId)
  } catch (e) {
    Sentry.captureException(e)
    return undefined
  }
}

const showBookBanner = computed(() => {
  return props.doc.doc_type === 'book' && aiLabel13537ExperimentVariant()
})

async function handleHighlight(route: RouteLocationNormalized): Promise<void> {
  const highlight = await _maybeFetchHighlight(route)
  if (highlight) {
    props.doc.scrollToHighlight(highlight)
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DocLayout, { doc: __props.doc }, _createSlots({
    "page-content": _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["book-reading__content-editor content-editor", __props.doc.settings.cssClass]),
        style: _normalizeStyle({ 'font-family': __props.doc.settings.fontFamily }),
        onClick: onDocContentClick
      }, [
        (__props.doc.isCurrentPageChapter)
          ? (_openBlock(), _createBlock(Chapter, {
              key: 0,
              content: __props.doc.currentPage,
              class: "chapter-text"
            }, null, 8, ["content"]))
          : (__props.doc.isCurrentPageOpenQuestions)
            ? (_openBlock(), _createBlock(Exercise, {
                key: 1,
                content: __props.doc.currentExercise,
                isEOC: __props.doc.currentExercise.currentExercise.isExerciseEOC,
                class: "chapter-exercise"
              }, null, 8, ["content", "isEOC"]))
            : _createCommentVNode("", true)
      ], 6),
      _createVNode(PrevNext, { doc: __props.doc }, null, 8, ["doc"])
    ]),
    "page-footer": _withCtx(() => [
      (__props.doc.audio && __props.doc.controls.isPlayerRendered)
        ? (_openBlock(), _createBlock(AudioPlayer, {
            key: 0,
            doc: __props.doc
          }, null, 8, ["doc"]))
        : _createCommentVNode("", true),
      (!__props.doc.audio && __props.doc.has_audio && __props.doc.controls.isPlayerRendered)
        ? (_openBlock(), _createBlock(AudioPlayerDisabled, {
            key: 1,
            class: _normalizeClass(__props.doc.controls.playerClass)
          }, null, 8, ["class"]))
        : _createCommentVNode("", true)
    ]),
    _: 2
  }, [
    (__props.doc.showEarlyAccessBanner)
      ? {
          name: "banner",
          fn: _withCtx(() => [
            (_unref(showBookBanner))
              ? (_openBlock(), _createBlock(EarlyAccessBannerBook, { key: 0 }))
              : _createCommentVNode("", true),
            (__props.doc.doc_type === 'podcast_episode')
              ? (_openBlock(), _createBlock(EarlyAccessBannerPodcast, { key: 1 }))
              : _createCommentVNode("", true)
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["doc"]))
}
}

})